import { createLogic } from 'redux-logic'
import * as constants from '../constants'
import { map, take } from 'rxjs/operators'

export const getProperties = createLogic({
  type: constants.GET_PROPERTIES.ACTION,
  processOptions: {
    successType: constants.GET_PROPERTIES.FULFILLED,
    failType: constants.GET_PROPERTIES.REJECTED
  },
  process({ http, action }) {
    const payload = { suggestion: { propertyName: action.payload.propertyName } }

    return http
      .post('/api/common/search/propertySuggestion', { ...payload })
      .pipe(
        take(1),
        map(http.getBody),
        map(res => (
          {
            total: res.total,
            data: res.data
          }
        ))
      )
  }
})
